export default "__VITE_ASSET__DNCJXIn9__"